export const tenderVersionCopy = {
  ru: {
    announcement: 'Объявление',
    lot: 'Лот',
    title: 'У объявления есть более новая версия',
    description: 'Перед подачей заявки откройте последнюю версию и проверьте её статус и документацию.',
    latest: 'Последняя версия',
    latestKnown: 'Последняя найденная версия',
    incomplete: 'Показана последняя версия из загруженных данных.',
  },
  kk: {
    announcement: 'Хабарландыру',
    lot: 'Лот',
    title: 'Хабарландырудың жаңа нұсқасы бар',
    description: 'Өтінім бермес бұрын соңғы нұсқаны ашып, оның мәртебесі мен құжаттамасын тексеріңіз.',
    latest: 'Соңғы нұсқа',
    latestKnown: 'Соңғы табылған нұсқа',
    incomplete: 'Жүктелген деректердегі соңғы нұсқа көрсетілген.',
  },
};
